import React, { Component } from "react"

import Screen from '../../ui/Screen'

import ControlPanel from "./EditPurchaseScreen/ControlPanel"
import TitlePanel from "./EditPurchaseScreen/TitlePanel"
import AttachmentsList from "./EditPurchaseScreen/AttachmentsList"
import ButtonPanel from "./EditPurchaseScreen/ButtonPanel"
import EditAttachmentDialog from "./EditPurchaseScreen/EditAttachmentDialog"
import RemoveAttachmentDialog from "./EditPurchaseScreen/RemoveAttachmentDialog"
import SelectItemDialog from "./../../inventory/SelectItemDialog"
import SelectTemplateDialog from "../../purchases_templates/SelectTemplateDialog"
import FilterSelectShops from "./EditPurchaseScreen/FilterSelectShops"
import SaveDialog from "./EditPurchaseScreen/SaveDialog"

import ErrorMessageDialog from "../../ui/ErrorMessageDialog"
import api from "./../../api"

/**
 * purchase - закупка.
 * checkboxes - показывать или нет чекбоксы (не надо вовремя создания) {true/false}.
 * 
 * # onSaveClick(purchase)
 * # onCancelClick
 * 
 * onCloseClick
 */

class EditPurchaseScreen extends Component {

    constructor(props) {

        super(props)

        this.newItemIdCounter = 0

        this.purchase = global.structuredClone(this.props.purchase)

        this.state = {
            dialog: undefined,
            screen: undefined,
            selected: undefined,
            filter_shops: [],
        }

        this.update = this.update.bind(this)
        this.handle_editAttachmentClick = this.handle_editAttachmentClick.bind(this)
        this.handle_error = this.handle_error.bind(this)

    }

    async update() {
        return
    }

	handle_error(error) {
        let message = error instanceof String ? error : error.message
		this.setState({
			dialog: <ErrorMessageDialog 
				message = {message}
				onClose = {() => {
					this.update()
						.then(() => this.setState({dialog: undefined}))
						.catch(this.handle_error)
				}}
			/>
		})
	}    

    componentDidMount() {
        this.setState({purchase: global.structuredClone(this.props.purchase)})
    }

    handle_editAttachmentClick = attachment => {
        this.setState({
            dialog: <EditAttachmentDialog 
                attachment = {attachment}
                onSaveClick = {attachment => {
                    api.purchases.attachments.update(attachment.id, attachment.quantity, attachment.shop_id, attachment.checked)
                        .then(() => {
                            for (let n in this.purchase.attachments) {
                                if (this.purchase.attachments[n].id === attachment.id) {
                                    this.purchase.attachments[n] = attachment
                                    break
                                }
                            }
                            this.setState({dialog: undefined})
                        })
                        .catch(this.handle_error)
                }}
                onCancelClick = {() => {this.setState({dialog: undefined})}}
            />
        })
    }

    render() {

        return <Screen
            onClick = {e => {
                e.stopPropagation()
                if (!this.state.dialog) {this.setState({selected: undefined})}
            }}        
        >

            {this.state.dialog}

            <TitlePanel title = {`Редактирование закупки: ${this.purchase.name}`} />

            <ControlPanel

                selected = {this.state.selected}

                onAttachItemClick = {() => {
                    this.setState({
                        dialog: <SelectItemDialog 
                            onSelectItem = {item => {
                                this.newItemIdCounter++
                                let attachment = {
                                    id: "new_" + this.newItemIdCounter,
                                    item: item,
                                    item_id: item.id,
                                    quantity: 1,
                                }
                                if (item.shops.length) {
                                    attachment.shop_id = item.shops[0].id
                                    attachment.shop = item.shops[0]
                                }
                                this.setState({
                                    dialog: <EditAttachmentDialog 
                                        attachment = {attachment}
                                        onSaveClick = {attachment => {
                                            api.purchases.attachments.create(
                                                this.purchase.id,
                                                attachment.item_id,
                                                attachment.quantity,
                                                attachment.shop_id
                                            )
                                                .then(response => api.purchases.attachments.get(response.id))
                                                .then(response => {
                                                    attachment = response.attachment
                                                    this.purchase.attachments.push(attachment)
                                                    this.setState({dialog: undefined, selected: attachment})
                                                })
                                                .catch(this.handle_error)
                                        }}
                                        onCancelClick = {() => this.setState({dialog: undefined})}
                                    />
                                })
                            }}
                            onCancel = {() => this.setState({dialog: undefined})}
                        />
                    })
                }}

                onAttachTemplateClick = {() => {
                    this.setState({dialog: <SelectTemplateDialog
                        onSelectClick = {template => {
                            this.setState({dialog: undefined})

                            const createAttachments = async () => {
                                try {
                                    for (let attachment of template.attachments) {
                                        await api.purchases.attachments.create(
                                            this.purchase.id,
                                            attachment.item_id,
                                            attachment.quantity,
                                            attachment.shop_id
                                        )
                                            .then(response => api.purchases.attachments.get(response.id))
                                            .then(response => {
                                                attachment = response.attachment
                                                this.purchase.attachments.push(attachment)
                                                this.setState({dialog: undefined, selected: attachment})
                                            })
                                    }
                                }
                                catch (error) {
                                    this.handle_error(error)
                                }
                            }

                            createAttachments()

                        }}
                        onCancelClick = {() => this.setState({dialog: undefined})}
                    />})
                }}

                onRemoveItemClick = {attachment => {this.setState({
                    dialog: <RemoveAttachmentDialog 
                        attachment = {attachment}
                        onRemoveClick = {attachment => {
                            api.purchases.attachments.delete(attachment.id)
                                .then(() => {
                                    for (let n in this.purchase.attachments) {
                                        if (this.purchase.attachments[n].id === attachment.id) {
                                            this.purchase.attachments.splice(n, 1)
                                        }
                                    }
                                    this.setState({dialog: undefined, selected: undefined})
                                })
                                .catch(this.handle_error)
                        }}
                        onCancelClick = {() => {this.setState({dialog: undefined})}}
                    />
                })}}

                onFilterClick = {() => {
                    this.setState({dialog: <FilterSelectShops 
                        purchase = {this.purchase}
                        filter_currentShopList = {this.state.filter_shops}
                        onSelectClick = {filter_shops => {
                            this.setState({
                                dialog: undefined,
                                filter_shops
                            })
                        }}
                        onCancelClick = {() => this.setState({dialog: undefined})}
                    />})
                }}

                onSaveClick = {() => {
                    this.setState({dialog: <SaveDialog 
                        purchase = {this.purchase}
                        filter_shops = {this.state.filter_shops}
                        onSaveClick = {content => {
                            // Сохранение в .csv
                            const link = document.createElement("a")
                            const file = new Blob([content], {type: "text/plain"})
                            link.href = URL.createObjectURL(file)
                            link.download = this.purchase.name + ".csv"
                            link.click()
                            URL.revokeObjectURL(link.href)

                            this.setState({dialog: undefined})
                        }}
                        onCancelClick = {()=>this.setState({dialog: undefined})}
                    />})
                }}

                onEditClick = {this.handle_editAttachmentClick}
            />

            <AttachmentsList 
                attachments = {this.purchase.attachments}
                selected = {this.state.selected}
                checkboxes = {this.props.checkboxes}
                filter_shops = {this.state.filter_shops}
                onClickAttachment = {attachment => {this.setState({selected: attachment})}}
                onDoubleClickAttachment = {this.handle_editAttachmentClick}
                onCheckAttachmentClick = {attachment => {
                    api.purchases.attachments.check(attachment.id, !attachment.checked).
                        then(() => {
                            attachment.checked = Number(attachment.checked) ? 0 : 1
                            this.setState({selected: attachment})
                        })
                        .catch(this.handle_error)
                }}
            />

            <ButtonPanel
                // onSaveClick = {() => {
                //     if (typeof this.props.onSaveClick === "function") {
                //         this.props.onSaveClick(this.purchase)
                //     }
                // }}
                // onCancelClick = {() => {
                //     if (typeof this.props.onCancelClick === "function") {
                //         this.props.onCancelClick()
                //     }
                // }}
                onCloseClick = {() => {
                    if (typeof this.props.onCloseClick === "function") {
                        this.props.onCloseClick()
                    }
                }}
            />

        </Screen>
        
    }

}

export default EditPurchaseScreen